export const competitionLevelsOptions = [
  { value: "ncaa_d1", label: "NCAA - D1" },
  { value: "ncaa_d2", label: "NCAA - D2" },
  { value: "ncaa_d3", label: "NCAA - D3" },
  { value: "naia", label: "NAIA" },
  { value: "juco", label: "JUCO" },
  { value: "high_school", label: "High School" },
  { value: "college_summer_team", label: "College Summer Team" },
  { value: "professional", label: "Professional" },
  { value: "facility", label: "Facility" },
] as const;
